<script setup lang="ts">
import { useUserStore } from './stores/user'
import ToastContainer from './components/ToastContainer.vue'
const userStore = useUserStore()
</script>

<template>
  <div v-if="userStore.isImpersonating" class="bg-cc-warning/10 border-b border-cc-warning/20 px-4 py-2 flex items-center justify-between">
    <div class="flex items-center gap-2">
      <span class="text-cc-warning font-medium flex items-center gap-1.5"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/></svg> Impersonating: {{ userStore.user?.name || 'Unknown User' }}</span>
      <span class="text-cc-text text-sm">({{ userStore.user?.role }})</span>
    </div>
    <button
      @click="userStore.stopImpersonation()"
      class="px-3 py-1 bg-cc-warning text-cc-btn-text text-sm font-medium rounded hover:opacity-90 transition"
    >
      Exit Impersonation
    </button>
  </div>
  <router-view />
  <ToastContainer />
</template>
